import script from "./commissionHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./commissionHistory.vue?vue&type=script&setup=true&lang=js"

import "./commissionHistory.vue?vue&type=style&index=0&id=c987b2f2&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c987b2f2"]])

export default __exports__